import { Device, DeviceID, OnlineDevicesSubscriptionBuzzerBuzzerHandlers } from '@playq/octopus2-devices';
import type { ClientEvent } from '@playq/services-vortex';

import { buzzerOnlineDevicesNotifications$ } from '/common/buzzer/buzzerNotifications';
import { Context } from '/api/types';

export class BuzzerOnlineHandlers extends OnlineDevicesSubscriptionBuzzerBuzzerHandlers<Context, string> {
  status(_context: Context, status: Device) {
    buzzerOnlineDevicesNotifications$.next(status);
    return Promise.resolve();
  }

  event(_context: Context, device: DeviceID, event: ClientEvent) {
    buzzerOnlineDevicesNotifications$.next({ device, event });
    return Promise.resolve();
  }
}
